import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { Button, Input, Switch } from 'antd'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import FormLine from '../../../Components/shared/Forms/FormLine'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'

import '../../../assets/school-permission-form.scss'

const InternshipRequestMetadataForm = ({ data, onSubmit }) => {
  const t = useSelector(selectTranslate)

  const [item, setItem] = useState(null)

  useEffect(() => {
    setItem({ ...data })

    return () => {
      setItem(null)
    }
  }, [data])

  return (
    <div className='school-permission-form'>
      {item !== null && (
        <>
          <FormLine label={t('common.name')} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <Input
              dataKey='name'
              value={item.name ?? null}
              onChange={e => setItem({ ...item, name: e.target.value })}
            />
            <IconLabel icon={faInfoCircle} text={t('metadata_form.type_information')} padding={0} fontSize={FontSizes.SMALL} />
          </FormLine>
          <FormLine label={t('common.mandatory')} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <Switch
              dataKey='isMandatory'
              checked={item.isMandatory ?? false}
              onChange={checked => setItem({ ...item, isMandatory: checked })}
            />
          </FormLine>
          <div className='form-footer'>
            <Button type='primary' onClick={() => onSubmit(item)}>{t('Validate')}</Button>
          </div>
        </>
      )}
    </div>
  )
}

export default InternshipRequestMetadataForm
